export const COMPLIANT = 'compliant'
export const NON_COMPLIANT = 'non_compliant'
export const NOT_APPLICABLE = 'not_applicable'
export type ComplianceStatus = typeof COMPLIANT | typeof NON_COMPLIANT | typeof NOT_APPLICABLE
export const DATE_HEADER = 'Date'
